import { render, staticRenderFns } from "./EpisodesCardsVertical.vue?vue&type=template&id=a5403ad2&scoped=true&"
import script from "./EpisodesCardsVertical.vue?vue&type=script&lang=js&"
export * from "./EpisodesCardsVertical.vue?vue&type=script&lang=js&"
import style0 from "./EpisodesCardsVertical.vue?vue&type=style&index=0&id=a5403ad2&prod&scoped=true&lang=css&"
import style1 from "./EpisodesCardsVertical.vue?vue&type=style&index=1&id=a5403ad2&prod&lang=css&"
import style2 from "./EpisodesCardsVertical.vue?vue&type=style&index=2&id=a5403ad2&prod&scoped=true&lang=scss&"
import style3 from "./EpisodesCardsVertical.vue?vue&type=style&index=3&id=a5403ad2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5403ad2",
  null
  
)

export default component.exports